export const initialReportState = {
  currentReport: {
    reportDetail: null,
    users: { raw: [], formatted: [] },
    me: { raw: {}, formatted: {} },
    relativeFields: {},
    investigation: {
      id: null,
      name: null,
      involvedsInfo: { raw: [], formatted: [] },
      involvedsAccompliceInfo: { raw: [], formatted: [] },
      involvedsOffenderInfo: { raw: [], formatted: [] },
      involvedsVictimInfo: { raw: [], formatted: [] },
      involvedsWitnessInfo: { raw: [], formatted: [] },
      humanResourcesInfo: {
        raw: [],
        formatted: [],
        approved: [],
        approvedFormatted: [],
      },
      accessResourcesInfo: {
        raw: [],
        formatted: [],
        approved: [],
        approvedFormatted: [],
      },
      financialResourcesInfo: {
        raw: [],
        formatted: [],
        approved: [],
        approvedFormatted: [],
      },
      materialResourcesInfo: {
        raw: [],
        formatted: [],
        approved: [],
        approvedFormatted: [],
      },
    },
  },
};

export const reportReducer = (state, action) => {
  switch (action.type) {
    case "SET_CURRENT_REPORT":
      return {
        ...state,
        currentReport: {
          ...state.currentReport,
          ...action.payload,
        },
      };
    case "SET_CURRENT_REPORT_INVESTIGATION":
      return {
        ...state,
        currentReport: {
          ...state.currentReport,
          investigation: {
            ...state.currentReport.investigation,
            ...action.payload,
          },
        },
      };
    case "RESET_REPORT":
      return initialReportState;
    default:
      return state;
  }
};
